import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';

// Mount inside <BrowserRouter>. Forwards Capacitor App URL events into
// react-router on native. Renders nothing.
export function NativeDeepLinkBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let listenerHandle: { remove: () => Promise<void> } | undefined;

    void CapacitorApp.addListener('appUrlOpen', (event) => {
      try {
        const url = new URL(event.url);
        // Legacy /billing is a server-side redirect on web; honour inline on native.
        const pathname = url.pathname === '/billing' ? '/profile/payment' : url.pathname;
        navigate(`${pathname}${url.search}${url.hash}`);
      } catch {
        // Malformed URL — ignore.
      }
    }).then((h) => { listenerHandle = h; });

    return () => {
      void listenerHandle?.remove();
    };
  }, [navigate]);

  return null;
}
